import { usePathname, useRouter } from 'next/navigation'
import { useEffect } from 'react'

import useSessionStore from '@/stores/useSessionStore'

/**
 * Redirects to /login if the current route is /book/pay and there is no auth token.
 */
export default function useAuthGate(): void {
  const authToken = useSessionStore((state) => state.authToken)
  const hasHydrated = useSessionStore((state) => state.hasHydrated)
  const pathname = usePathname()
  const router = useRouter()

  useEffect(() => {
    if (
      hasHydrated &&
      !authToken &&
      (pathname.startsWith('/book/travelers') || pathname.startsWith('/book/pay'))
    )
      router.push('/book/login')
  }, [authToken, hasHydrated, pathname, router])

  useEffect(() => {
    if (
      hasHydrated &&
      !authToken &&
      pathname.startsWith('/users') &&
      !pathname.startsWith('/users/password/edit')
    )
      router.push('/')
  }, [authToken, hasHydrated, pathname, router])
}
